import { useEffect, useState } from "react";
import "./css/CookieConsent.css";

const COOKIE_CONSENT_NAME = "cookieConsent";

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getCookie(COOKIE_CONSENT_NAME);
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setCookie(COOKIE_CONSENT_NAME, "accepted", 365); // 1 year expiration
    setIsVisible(false);
  };

  const handleReject = () => {
    setCookie(COOKIE_CONSENT_NAME, "rejected", 30); // 30 days expiration
    setIsVisible(false);
  };

  const setCookie = (name, value, days) => {
    const expires = new Date(
      Date.now() + days * 24 * 60 * 60 * 1000
    ).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <h3 className="cookie-title">🍪 We Value Your Privacy</h3>
        <p className="cookie-message">
          We use cookies to enhance your browsing experience, serve personalized
          content, and analyze our traffic. By clicking "Accept All", you
          consent to our use of cookies. You can change your preferences
          anytime.
        </p>
        <div className="cookie-actions">
          <button
            className="cookie-btn cookie-btn-settings"
            onClick={handleReject}
          >
            Reject Non-Essential
          </button>
          <button
            className="cookie-btn cookie-btn-accept"
            onClick={handleAccept}
          >
            Accept All Cookies
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
